// extracted by mini-css-extract-plugin
module.exports = {"label":"RecentSearches_label__2R2jG","content":"RecentSearches_content__2Zmil"};